import React from 'react';
import { XCircle } from 'lucide-react';
const pains = ['Llegás al campo sin saber exactamente qué ejercicio vas a dar hoy', 'Tus jugadores no progresan porque no hay un orden claro en los contenidos', 'Tenés grupos con niveles muy distintos y no sabés cómo nivelar sin frenar a los buenos ni perder a los flojos', 'Cuando falta un jugador o hay partido el fin de semana perdés la continuidad del proceso', 'No podés justificar tu rol como entrenador porque no tenés nada sistematizado ni registrado', 'Llegás a casa después del entrenamiento con la sensación de que "algo faltó" pero no sabés exactamente qué', 'Nadie valora tu trabajo porque no se ve reflejado en la mejora concreta de los jugadores', 'Te quedás hasta tarde "armando algo" para el entrenamiento de mañana cuando ya estás agotado'];
export function PainSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-20 px-4" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-177">
          Si sos entrenador de rugby, esto te va a sonar conocido:
        </h2>

        <div className="space-y-6 mb-16" data-id="element-178">
          {pains.map((pain, i) => <div key={i} className="flex items-start gap-4 bg-red-50/50 p-4 rounded-xl" data-id="element-179">
              <XCircle className="text-red-500 flex-shrink-0 mt-1" size={24} data-id="element-180" />
              <p className="text-lg text-gray-800 font-medium leading-relaxed" data-id="element-181">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FFF9C4] p-8 rounded-2xl text-center shadow-sm border border-yellow-200" data-id="element-182">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" data-id="element-183">
            "¿Cuántos entrenamientos más vas a improvisar?"
          </h3>
          <button onClick={scrollToPricing} className="bg-[#1B4D2E] hover:bg-[#143d24] text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:scale-105 w-full md:w-auto" data-id="element-184">
            👉 BASTA DE IMPROVISAR — QUIERO MI RUGBY 360
          </button>
        </div>
      </div>
    </section>;
}